module.exports = __webpack_public_path__ + "img/icon.0ec2ed5f.png";